import React, { Component } from "react";
import Nav from "react-bootstrap/Nav";

import Paragraph from "../components/tutorial/Paragraph";
import Bold from "../components/tutorial/Bold";
import ToolTip from "../components/tutorial/ToolTip";
import LinkedText from "../components/tutorial/LinkedText";

import "./TutorialContainer.css";

const assets = require.context("../assets", true);

class TutorialContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentContentIndex: 1,
      currentContentPage: 0,
      firstContent: true,
      lastContent: this.isSingleContentBlock(),
      content: this.generateContent(),
    };
    this.props.changeCurrentPage(this.props.page.id);
    this.clickThroughContent = this.clickThroughContent.bind(this);
  }

  whichContent(c) {
    switch (c.type) {
      case "horizontal":
        return (
          <div key={c.src} className="text-center">
            <div className="justify-content-center row">
              {c.content.map((c) => (
                <div className="col-md-auto">{this.whichContent(c)}</div>
              ))}
            </div>
            {c.caption && <p style={{ fontSize: "75%" }}>{c.caption}</p>}
          </div>
        );
      case "text":
        return <Paragraph key={c.content} content={c.content} />;
      case "bold":
        return (
          <Bold
            key={c.content}
            beforeContent={c.beforeContent}
            afterContent={c.afterContent}
            boldWords={c.boldWords}
          />
        );
      case "custom":
        return c.content;
      case "link":
        return (
          <LinkedText
            key={c.content}
            isButton={c.isButton}
            linkAnchors={c.linkAnchors}
            links={c.links}
            beforeContent={c.beforeContent}
            afterContent={c.afterContent}
          />
        );
      case "tooltip":
        return (
          <ToolTip
            key={c.activeWords[0]}
            beforeContent={c.beforeContent}
            afterContent={c.afterContent}
            activeWords={c.activeWords}
            tooltips={c.tooltips}
          />
        );
      case "image":
        let figure = assets(`./images/${c.src}`);
        return (
          <div key={c.src} className="text-center">
            <img className="tut-img py-2" src={figure} alt={c.alt} />
            {c.caption && <p style={{ fontSize: "75%" }}>{c.caption}</p>}
          </div>
        );
      case "video":
        let vid = assets(`./videos/${c.src}`);
        return (
          <div key={c.src} className="text-center">
            <video className="tut-vid" alt={c.alt} controls>
              <source src={vid} type="video/mp4" />
            </video>
            {c.caption && <p style={{ fontSize: "75%" }}>{c.caption}</p>}
          </div>
        );
      default:
        return <div />;
    }
  }

  isSingleContentBlock() {
    return (
      this.props.page.content[0].length === 1 &&
      this.props.page.content.length === 1
    );
  }

  generateContent() {
    let content = this.props.page.content.map((content) =>
      content.map((c) => this.whichContent(c))
    );
    return content;
  }

  clickThroughContent(direction) {
    const { currentContentIndex, currentContentPage, content } = this.state;

    let increment = -1;
    if (direction === "forwards") {
      increment = 1;
    }

    let currentIndex = currentContentIndex + increment;
    let currentPage = currentContentPage;
    // finished the content for the current page move to next page
    if (currentIndex === content[currentContentPage].length + 1) {
      currentPage += 1;
      currentIndex = 1;
    }
    // go back to previous page
    if (currentIndex === 0) {
      currentPage -= 1;
      currentIndex = content[currentPage].length;
    }
    // only one piece of content on the page
    if (content[currentContentPage].length === 1) {
      this.setState({
        lastContent: false,
        firstContent: false,
      });
    }
    // on second to last page want nav link to appear on last page and there's only one piece of content on last page
    else if (
      1 === content[currentPage].length &&
      content.length - 1 <= currentPage
    ) {
      this.setState({
        lastContent: true,
        firstContent: false,
      });
      // on second to last page want nav link to appear on last page
    } else if (
      currentIndex === content[currentContentPage].length &&
      content.length - 1 <= currentPage
    ) {
      this.setState({
        lastContent: true,
        firstContent: false,
      });
      // on second page want nav link to appear on first page
    } else if (currentIndex === 1 && currentPage === 0) {
      this.setState({
        firstContent: true,
        lastContent: false,
      });
      // on a page in the middle
    } else {
      this.setState({
        lastContent: false,
        firstContent: false,
      });
    }

    this.setState({
      currentContentPage: currentPage,
      currentContentIndex: currentIndex,
    });
  }

  render() {
    const { firstPage, lastPage, page } = this.props;
    const {
      firstContent,
      lastContent,
      content,
      currentContentPage,
      currentContentIndex,
    } = this.state;

    return (
      <div className="outer pl-5 page-container">
        <div className="fill p-4 mb-4 content-wrap text-large">
          <h2 style={{ fontSize: "1.75rem" }}>
            <u>{page.name}</u>
          </h2>
          {content[currentContentPage].slice(0, currentContentIndex)}
          <p></p>
        </div>
        <div className="row col-md-11 col-11" id="tut-nav">
          <div className="col-md-6 col-6 float-left">
            {!firstPage && firstContent ? (
              <Nav.Link
                href={`/tutorial/${this.props.page.id - 1}`}
                role="alert"
                className="btn btn-primary float-left"
              >
                <i className="fa fa-arrow-left"></i> Back
              </Nav.Link>
            ) : (
              !firstContent && (
                <button
                  className="nav nav-link btn btn-primary float-left"
                  onClick={() => this.clickThroughContent("backwards")}
                  role="alert"
                >
                  <i className="fa fa-arrow-left"></i> Back
                </button>
              )
            )}
          </div>
          <div className="col-md-6 col-6 float-right">
            {!lastPage && lastContent ? (
              <Nav.Link
                href={`/tutorial/${this.props.page.id + 1}`}
                role="alert"
                className="btn btn-primary float-right"
              >
                Next <i className="fa fa-arrow-right"></i>
              </Nav.Link>
            ) : (
              !lastContent && (
                <button
                  className="nav nav-link btn btn-primary float-right"
                  onClick={() => this.clickThroughContent("forwards")}
                  role="alert"
                >
                  Next <i className="fa fa-arrow-right"></i>
                </button>
              )
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default TutorialContainer;
